
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useQuery } from "@vue/apollo-composable";

import HeaderBlock from "@/components/HeaderBlock.vue";
import PaginatedEntitiesList from "@/components/list/PaginatedEntitiesList.vue";
import AddClient from "../../components/CRUXEntity/AddClient.vue";
import BasicButton from "../../components/BasicButton.vue";

import { GET_CLIENTS } from "@/graphql/client/queries";
import { GET_USER } from "@/graphql/user/queries";

import enUK from "@/locales/client/en-UK.json";
import { Client } from "@/helpers/client/typesDefinition";
import { isAdmin } from "@/helpers/router/queries";

type MessageSchema = typeof enUK;

export default defineComponent({
  setup() {
    const { t } = useI18n<[MessageSchema], "en-UK">({
      useScope: "global",
      inheritLocale: true,
      messages: {
        "en-UK": enUK,
      },
    });

    // Get user for role checking
    const { result: userResult } = useQuery(GET_USER);
    const user = computed(() => userResult.value?.user);
    const isUserAdmin = computed(() => isAdmin(user.value?.accessRights));

    return {
      t,
      isUserAdmin,
    };
  },
  data() {
    return {
      enUK,
      GET_CLIENTS,
      isModalVisible: false,
    };
  },
  methods: {
    showModal(): void {
      this.isModalVisible = true;
    },
    closeModal(): void {
      this.isModalVisible = false;
    },
    viewEntity(client: Client): void {
      // Navigate based on user role
      if (this.isUserAdmin) {
        this.$router.push({
          name: "ClientProjects",
          params: { id: client.id },
        });
      } else {
        this.$router.push({ name: "ClientUsers", params: { id: client.id } });
      }
    },
  },
  components: {
    HeaderBlock,
    PaginatedEntitiesList,
    AddClient,
    BasicButton,
  },
  provide: {
    columnsOrder: {
      name: null,
    },
  },
});
